<div class="flex items-start justify-between px-6 pt-6">
   <h2 class="mat-headline-medium">{{ 'approval.feedback_title' | translate: { name: data.approvalRequest.title } }}</h2>
   <div class="flex items-center">
      @if (attachmentId() !== null) {
         <webvis-feature-share-link-indicator
            [targetConfig]="shareLinkTargetConfig"
            [targetId]="attachmentId()"
         />
      }
      <button
         (click)="useFullScreen.set(!useFullScreen())"
         [matTooltip]="(useFullScreen() ? 'general.collapse' : 'general.expand') | translate"
         mat-icon-button
      >
         <fa-icon [icon]="useFullScreen() ? ['far', 'arrows-minimize'] : ['far', 'arrows-maximize']" />
      </button>
      <button
         (click)="onClose()"
         mat-icon-button
      >
         <fa-icon [icon]="['far', 'xmark']" />
      </button>
   </div>
</div>

<div
   [class.grid-cols-[1fr_19fr]]="useFullScreen()"
   [class.grid-cols-[1fr_2fr]]="!useFullScreen()"
   class="flex-1 min-h-0 grid gap-4 px-6 transition-[grid-template-columns] duration-300 ease-in-out"
>
   <div class="flex flex-col gap-2 overflow-y-auto overflow-x-hidden min-h-0 min-w-0">
      <div class="flex flex-col gap-1">
         <div class="flex items-center gap-2">
            <span class="mat-body-large-prominent flex-1 text-on-surface-variant">{{ 'approval.deadline' | translate }}</span>
            <span class="mat-body-large flex-1">{{ data.approvalRequest.deadline | customDate }}</span>
         </div>
         <div class="flex flex-col gap-1 py-2">
            <span class="mat-body-large-prominent text-on-surface-variant">{{ 'approval.description' | translate }}</span>
            <span class="mat-body-large">{{ data.approvalRequest.description }}</span>
         </div>
      </div>

      @if (!data.config.readonly && userIsReviewer()) {
         <mat-divider class="mx-4" />

         <mat-button-toggle-group
            [formControl]="approvedControl"
            [hideSingleSelectionIndicator]="true"
            class="min-h-fit my-2"
         >
            <mat-button-toggle
               #rejectToggle
               [ngClass]="rejectToggle.checked ? 'bg-errorContainer text-onErrorContainer' : ''"
               [value]="false"
               class="flex-auto"
            >
               @if (rejectToggle.checked) {
                  <fa-icon
                     [icon]="['far', 'check']"
                     class="mr-2"
                  />
               }
               {{ 'general.reject' | translate }}
            </mat-button-toggle>
            <mat-button-toggle
               #approveToggle
               [ngClass]="approveToggle.checked ? 'bg-extendedSafeContainer text-extendedOnSafeContainer' : ''"
               [value]="true"
               class="flex-auto"
            >
               @if (approveToggle.checked) {
                  <fa-icon
                     [icon]="['far', 'check']"
                     class="mr-2"
                  />
               }
               {{ 'general.approve' | translate }}
            </mat-button-toggle>
         </mat-button-toggle-group>

         @if (approvalChoiceMade()) {
            <shared-ui-text-input
               [inputFormControl]="elaborationControl"
               [label]="(approvedControl.value === false ? 'approval.elaboration' : 'general.additional_remark') | translate"
               [placeholder]="(approvedControl.value === false ? 'approval.elaboration_placeholder' : 'general.approve_placeholder') | translate"
               type="multi"
            />

            <div
               *webvisAclRestrict="overridePermission"
               class="flex items-center gap-2"
            >
               <mat-checkbox [formControl]="overrideControl">
                  {{ 'approval.override' | translate }}
               </mat-checkbox>
               <fa-icon
                  [icon]="['far', 'circle-info']"
                  [matTooltip]="'approval.override_tooltip' | translate"
                  class="text-on-surface-variant"
               />
            </div>
         }
      }

      <mat-divider class="mx-4" />

      <webvis-feature-approval-feedback-reviewers-display [reviewers]="data.approvalRequest.reviewers" />

      <webvis-feature-approval-feedback-comments
         *webvisAclRestrict="commentRestriction"
         (commentDeleted)="onCommentDelete($event)"
         (commentEditSubmitted)="onCommentEdit($event)"
         (commentSubmitted)="onCommentSubmit($event)"
         (goToSlide)="onGoToSlide($event)"
         [comments]="comments()"
         [currentSlide]="currentSlide()"
         [currentUserId]="currentUser()?.id"
         [loading]="commentsLoading()"
      />
   </div>

   <div class="relative flex flex-col overflow-hidden min-h-0">
      <webvis-feature-approval-url-preview
         (pageChange)="onPageChange($event)"
         [saveFileName]="data.approvalRequest.title"
         [url]="attachmentUrl()"
         class="flex-1 overflow-hidden"
      />
   </div>
</div>

<div class="flex items-center gap-4 px-6 py-3">
   <button
      (click)="onClose()"
      class="min-w-[200px]"
      mat-button
   >
      {{ 'general.close' | translate }}
   </button>
   @if (!data.config.readonly) {
      <span class="flex-1"></span>
      <button
         (click)="onFinish()"
         [disabled]="!approvalChoiceMade() || saving()"
         [loading]="saving()"
         class="min-w-[200px]"
         mat-flat-button
      >
         {{ 'approval.finish' | translate }}
      </button>
   }
</div>
